module.exports = __webpack_public_path__ + "media/images/flags/32/Bolivia-956cd619ac04259a548b75480ddcc1b4.png";